import React from 'react'
import groupByInitial from '../../../client/functions/groupByInitial'
import { offeringInternship } from '../../functions/exhibitorViews'
import { LABELS } from '../../constants/staticText'
import { Ueberschrift } from '../../../lib/a11y/Ueberschrift'
import ExhibitorProfileLink from '../../../lib/components/ExhibitorProfileLink'

// „Die Aussteller & ihre Praktikumsplätze": eine A–Z-Liste der Betriebe, die
// Praktika anbieten — ohne Berufe, wie auf der Live-Seite. Das Merkmal steht am
// Aussteller (participants.internship), nicht am Angebot (#13).
const InternshipExhibitors = ({ data }) => {
    const exhibitors = offeringInternship(data)

    if (0 === exhibitors.length) return <p className="section-empty">{LABELS.noExhibitors}</p>

    return (
        <div className="section-internships">
            <p className="section-intro">{LABELS.internshipsIntro}</p>
            {groupByInitial(exhibitors).map(group => (
                <section key={group.letter} className="letter-group">
                    <Ueberschrift className="letter-group-title">{group.letter}</Ueberschrift>
                    <ul className="letter-group-items">
                        {group.items.map(exhibitor => (
                            <li key={exhibitor.participantId}><ExhibitorProfileLink id={exhibitor.participantId}>{exhibitor.name}</ExhibitorProfileLink></li>
                        ))}
                    </ul>
                </section>
            ))}
        </div>
    )
}

export default InternshipExhibitors
